export const goLink = (link) => {
    window.open(link, '_blank', 'noopener, noreferrer');
}